"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RespondentKnowledge = exports.hiddenVariablesKey = exports.AnsweredConcept = exports.QA = exports.NextQ = void 0;
var properties_maker_1 = require("../../util/properties-maker");
var NextQ = /** @class */ (function () {
    function NextQ(arg) {
        this.id = arg.id;
    }
    return NextQ;
}());
exports.NextQ = NextQ;
var QA = /** @class */ (function () {
    function QA(arg) {
        this.questionId = arg.questionId;
        this.answers = arg.answers;
        if (arg.conceptId) {
            this.conceptId = arg.conceptId;
        }
    }
    return QA;
}());
exports.QA = QA;
var AnsweredConcept = /** @class */ (function () {
    function AnsweredConcept(arg) {
        this.nodeId = arg.nodeId;
        this.conceptIds = arg.conceptIds;
    }
    return AnsweredConcept;
}());
exports.AnsweredConcept = AnsweredConcept;
exports.hiddenVariablesKey = 'hiddenVariables';
var RespondentKnowledge = /** @class */ (function () {
    function RespondentKnowledge(arg) {
        this.taxonomyDevice = arg.taxonomyDevice;
        this.questionAnswers = arg.questionAnswers;
        this.screeningQuestionAnswers = arg.screeningQuestionAnswers || [];
        this.hiddenVariables = arg.hiddenVariables || {};
        if (arg.concepts) {
            this.concepts = arg.concepts;
        }
        if (arg.quotas) {
            this.quotas = arg.quotas;
        }
    }
    RespondentKnowledge.prototype.set = function (_a) {
        var key = _a.key, id = _a.id, value = _a.value;
        // access only read only properties
        if (key === exports.hiddenVariablesKey) {
            if (!this[key]) {
                this[key] = {};
            }
            if (!this[key][id]) {
                this[key][id] = [];
            }
            if (!this[key][id].includes(value)) {
                this[key][id].push(value);
            }
        }
    };
    RespondentKnowledge.prototype.unSet = function (_a) {
        var key = _a.key, id = _a.id, value = _a.value;
        // access only read only properties
        if (key === exports.hiddenVariablesKey && this[key][id]) {
            this[key][id] = this[key][id].filter(function (variableValue) { return variableValue !== value; });
        }
    };
    RespondentKnowledge.prototype.clear = function (_a) {
        var key = _a.key, id = _a.id;
        // access only read only properties
        if (key === exports.hiddenVariablesKey && this[key][id]) {
            this[key][id] = [];
        }
    };
    RespondentKnowledge.buildFrom = function (src, props) {
        return new RespondentKnowledge(properties_maker_1.PropertiesMaker.merge(src, props));
    };
    return RespondentKnowledge;
}());
exports.RespondentKnowledge = RespondentKnowledge;
